/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FriendInviteStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    EXPIRED: 'EXPIRED'
} as const;
export type FriendInviteStatus = typeof FriendInviteStatus[keyof typeof FriendInviteStatus];


export function instanceOfFriendInviteStatus(value: any): boolean {
    for (const key in FriendInviteStatus) {
        if (Object.prototype.hasOwnProperty.call(FriendInviteStatus, key)) {
            if (FriendInviteStatus[key as keyof typeof FriendInviteStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FriendInviteStatusFromJSON(json: any): FriendInviteStatus {
    return FriendInviteStatusFromJSONTyped(json, false);
}

export function FriendInviteStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FriendInviteStatus {
    return json as FriendInviteStatus;
}

export function FriendInviteStatusToJSON(value?: FriendInviteStatus | null): any {
    return value as any;
}

export function FriendInviteStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FriendInviteStatus {
    return value as FriendInviteStatus;
}

